import { css } from "@emotion/react";
import { Box, Stack, TextField } from "@mui/material";
import { InputBaseProps } from "@mui/material/InputBase";
import { appTypo } from "@unit/styles";
import React, { Dispatch, SetStateAction } from "react";

type Props = {
  type: "password" | "email" | "string" | "multiple";
  required: boolean;
  label?: string;
  title: string;
  value: string;
  error: boolean;
  helperText?: string;
  placeholder?: string;
  disabled?: boolean;
  maxMultilineRows?: number;
  onBlur?: InputBaseProps["onBlur"];
  onFocus?: InputBaseProps["onFocus"];
  onChange: Dispatch<SetStateAction<string>>;
};

const PrimaryForm: React.FC<Props> = (props) => {
  return (
    <Stack spacing={1}>
      <Box css={titleStyled}>{props.title}</Box>
      {props?.type === "password" && (
        <TextField
          margin="normal"
          fullWidth
          name="password"
          error={props.error}
          label={props?.label || undefined}
          value={props.value}
          required={props.required}
          type="password"
          autoComplete="current-password"
          size={"small"}
          helperText={props?.helperText && props.helperText}
          placeholder={props?.placeholder || undefined}
          onBlur={props.onBlur}
          onFocus={props.onFocus}
          onChange={(e) => props.onChange(e.target.value)}
        />
      )}
      {props?.type === "email" && (
        <TextField
          margin="normal"
          fullWidth
          error={props.error}
          label={props.label}
          value={props.value}
          required={props.required}
          name="email"
          autoComplete="email"
          size={"small"}
          helperText={props?.helperText && props.helperText}
          placeholder={props?.placeholder || undefined}
          onBlur={props.onBlur}
          onFocus={props.onFocus}
          onChange={(e) => props.onChange(e.target.value)}
        />
      )}
      {props.type === "string" && (
        <TextField
          error={props.error}
          label={props.label}
          value={props.value}
          required={props.required}
          variant="outlined"
          helperText={props?.helperText && props.helperText}
          size={"small"}
          disabled={props.disabled}
          placeholder={props?.placeholder || undefined}
          onBlur={props.onBlur}
          onFocus={props.onFocus}
          onChange={(e) => props.onChange(e.target.value)}
        />
      )}
      {props.type === "multiple" && (
        <TextField
          multiline
          maxRows={props?.maxMultilineRows || 5}
          error={props.error}
          label={props.label}
          value={props.value}
          required={props.required}
          variant="outlined"
          helperText={props?.helperText && props.helperText}
          size={"small"}
          disabled={props.disabled}
          placeholder={props?.placeholder || undefined}
          onBlur={props.onBlur}
          onFocus={props.onFocus}
          onChange={(e) => props.onChange(e.target.value)}
        />
      )}
    </Stack>
  );
};
export default React.memo(PrimaryForm);

const titleStyled = css`
  font-family: ${appTypo.font.notoJp};
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.1px;
`;
